import { DutyCodePeriod } from 'generated';
import { Control, Controller } from 'react-hook-form';

import DutyCodeSelector from '../DutyCodeSelector';

type Props = {
  control: Control<any>;
  disabled?: boolean;
  fullWidth?: boolean;
  label: string;
  name: string;
  onChange?: (...event: any[]) => void;
  referenceDate?: Date;
  required?: boolean;
  value?: number;
};

export type PeriodOption = DutyCodePeriod & {
  startTimeString: string;
  endTimeString: string;
};

export type Option = {
  id?: number;
  value?: number;
  label: string;
  startTime?: string;
  endTime?: string;
  periods?: PeriodOption[];
  description?: string;
};

const ControlledDutyCodeSelector = (props: Props) => {
  const {
    control,
    disabled,
    fullWidth,
    label,
    name,
    onChange,
    referenceDate,
    required
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <DutyCodeSelector
          variant="outlined"
          size="small"
          field={field}
          fieldState={fieldState}
          label={label}
          onChange={onChange}
          required={required}
          referenceDate={referenceDate}
          fullWidth={fullWidth}
          disabled={disabled}
        />
      )}
    />
  );
};

export default ControlledDutyCodeSelector;
